import { render, staticRenderFns } from "./Headercomp.vue?vue&type=template&id=490ce630&scoped=true&"
import script from "./Headercomp.vue?vue&type=script&lang=js&"
export * from "./Headercomp.vue?vue&type=script&lang=js&"
import style0 from "./Headercomp.vue?vue&type=style&index=0&id=490ce630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ce630",
  null
  
)

export default component.exports